import {CoreModel} from '../../model/CoreModel';
import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import SoundEvents from '../../events/SoundEvents';

// doThat = true: do not need an approvement parameter by default

const SwitchSoundOnOffState = (doThat = true) => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const model = CoreModel.instance();
        model.soundOn = !model.soundOn;

        if (model.soundOnChanged) {
            model.resetSoundOnChanged();
            CoreMessageDispatcher.instance().emit(SoundEvents.STATE_CHANGED);
            CoreMessageDispatcher.instance().emit(model.soundOn ? SoundEvents.ON : SoundEvents.OFF);
        }

        resolve(doThat);
    });
};

export {SwitchSoundOnOffState};
